import { z } from 'zod';

export const dashboardStatsSchema = z.object({
  cycleTime: z.object({
    avgWaitTime: z.number(),
    avgAttentionTime: z.number(),
    avgTotalTime: z.number(),
  }),
  resolutionEfficiency: z.object({
    delivered: z.number(),
    notDelivered: z.number(),
    avgTimeDelivered: z.number(),
    avgTimeNotDelivered: z.number(),
  }),
  heatmap: z.array(
    z.object({
      hour: z.number(),
      count: z.number(),
    })
  ),
  noShows: z.object({
    totalScheduled: z.number(),
    show: z.number(),
    noShow: z.number(),
    rate: z.number(),
  }),
  demandSource: z.object({
    agenda: z.number(),
    walkIn: z.number(),
  }),
  failureReasons: z
    .array(
      z.object({
        reason: z.string(),
        count: z.number(),
      })
    )
    .optional(),
  slaCompliance: z
    .object({
      global: z.object({
        withinSla: z.number(),
        outsideSla: z.number(),
        rate: z.number(),
      }),
      bySector: z.array(
        z.object({
          sectorName: z.string(),
          withinSla: z.number(),
          outsideSla: z.number(),
          rate: z.number(),
          targetTime: z.number(),
        })
      ),
    })
    .optional(),
  usersRanking: z
    .array(
      z.object({
        userName: z.string(),
        deliveredCount: z.number(),
      })
    )
    .optional(),
});

export type DashboardStats = z.infer<typeof dashboardStatsSchema>;
